const obligatoire = v => !!v || 'ne peut pas être vide';
const rgpd = v =>
  !!v || 'Vous devez cocher la case ci-dessus pour finaliser l’inscription';
const size = v =>
  (!!v && v.length <= 255) ||
  v === null ||
  v.length === 0 ||
  'maximum 255 caractères';

export default {
  methods: {
    obligatoireRule() {
      return obligatoire;
    },
    rgpdRule() {
      return rgpd;
    },
    size255Rule() {
      return size;
    },
  },
};
